import React, { useState, useEffect, useRef } from 'react';

const isReactSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const HeroImageCarousel = ({ images = [] }) => {
  const [layers, setLayers] = useState(() =>
    images.length > 0 ? [{ index: 0, active: true, id: 0 }] : []
  );
  const idRef = useRef(1);

  // Auto-advance: push a new layer every 7s, old one fades out
  useEffect(() => {
    if (images.length <= 1 || isReactSnap) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) return;

    const timer = setInterval(() => {
      const newId = idRef.current++;
      setLayers(prev => {
        const lastLayer = prev[prev.length - 1];
        const nextIdx = (lastLayer.index + 1) % images.length;
        const deactivated = prev.map(l => ({ ...l, active: false }));
        return [...deactivated.slice(-1), { index: nextIdx, active: true, id: newId }];
      });
    }, 12000);
    return () => clearInterval(timer);
  }, [images.length]);

  // Clean up faded-out layers after crossfade completes
  useEffect(() => {
    if (layers.length <= 1) return;
    const timeout = setTimeout(() => {
      setLayers(prev => prev.filter(l => l.active));
    }, 2500); // slightly longer than the 2s crossfade
    return () => clearTimeout(timeout);
  }, [layers.length]);

  if (images.length === 0) return null;

  return (
    <>
      {layers.map(layer => (
        <div
          key={layer.id}
          className="hero-carousel-fade"
          style={{ opacity: layer.active ? 1 : 0 }}
        >
          <div
            className="hero-carousel-kb"
            style={{ backgroundImage: `url(${images[layer.index]})` }}
            aria-hidden="true"
          />
        </div>
      ))}
    </>
  );
};

export default HeroImageCarousel;
